<template>
  <div class="terms-conditions">
    <h1>Terms and Conditions for Eye Academy - Online Medical Question Bank</h1>
    <p>
      Welcome to Eye Academy! These Terms and Conditions govern your use of our
      online medical question bank service. By accessing or using our website,
      you agree to be bound by these Terms and Conditions. If you disagree with
      any part of these Terms and Conditions, please do not use our services.
    </p>

    <section
      v-for="(item, index) in termsConditions"
      :key="index"
    >
      <h2 class="mt-6">{{ item.title }}</h2>
      <ul>
        <li
          v-for="(subItem, subIndex) in item.items"
          :key="`subItem-${subIndex}`"
        >
          <strong>{{ subItem.subTitle }}</strong>
          <p>{{ subItem.description }}</p>
        </li>
      </ul>
    </section>

    <p>
      By using Eye Academy, you acknowledge that you have read, understood, and
      agree to be bound by these Terms and Conditions. If you have any questions
      or concerns, please contact us at
      <a href="mailto:team@eye.academy">team@eye.academy</a>.
    </p>

    <p>
      If you are based in the EU you can also use the
      <a
        target="_blank"
        href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=EN"
        >Online Dispute Resolution Platform</a
      >.
    </p>
  </div>
</template>

<script>
  export default {
    name: "TermsAndConditions",
    data() {
      return {
        termsConditions: [
          {
            title: "1. Acceptance of Terms",
            items: [
              {
                subTitle: "1.1",
                description:
                  "By accessing or using Eye Academy, you agree to comply with these Terms and Conditions and all applicable laws and regulations.",
              },
              {
                subTitle: "1.2",
                description:
                  "If you do not agree with any part of these terms, you may not access the service.",
              },
            ],
          },
          {
            title: "2. Use of Service",
            items: [
              {
                subTitle: "2.1",
                description:
                  "Eye Academy provides a platform for users to access medical questions and related educational content for medical exams.",
              },
              {
                subTitle: "2.2",
                description:
                  "Users must be at least 18 years old to use our services or have the consent of a parent or legal guardian.",
              },
              {
                subTitle: "2.3",
                description:
                  "You are responsible for maintaining the confidentiality of your account and password and for restricting access to your account.",
              },
              {
                subTitle: "2.4",
                description:
                  "You agree to use Eye Academy for lawful purposes only and not to engage in any activity that disrupts the service or interferes with other users' enjoyment of the platform.",
              },
              {
                subTitle: "2.5",
                description:
                  "Eye Academy reserves the right to terminate or suspend access to the service for any user who violates these Terms and Conditions.",
              },
            ],
          },
          {
            title: "3. Intellectual Property Rights",
            items: [
              {
                subTitle: "3.1",
                description:
                  "All content on Eye Academy, including but not limited to text, graphics, logos, images, and software, is the property of Eye Academy or its licensors and is protected by copyright and other intellectual property laws.",
              },
              {
                subTitle: "3.2",
                description:
                  "Users may not reproduce, distribute, modify, or create derivative works of any content from Eye Academy without prior written consent.",
              },
            ],
          },
          {
            title: "4. User Content",
            items: [
              {
                subTitle: "4.1",
                description:
                  'Users may submit questions, comments, or other content ("User Content") to Eye Academy.',
              },
              {
                subTitle: "4.2",
                description:
                  "By submitting User Content, you grant Eye Academy a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, translate, distribute, and display such User Content in connection with the service.",
              },
              {
                subTitle: "4.3",
                description:
                  "You are solely responsible for the User Content you submit and agree not to submit any content that is unlawful, defamatory, obscene, or otherwise objectionable.",
              },
              {
                subTitle: "4.4",
                description:
                  "Eye Academy reserves the right to remove any User Content that violates these Terms and Conditions or is otherwise deemed inappropriate.",
              },
            ],
          },
          {
            title: "5. Privacy Policy",
            items: [
              {
                subTitle: "5.1",
                description:
                  "By using Eye Academy, you agree to the collection and use of your personal information as described in our Privacy Policy.",
              },
              {
                subTitle: "5.2",
                description:
                  "We are committed to protecting your privacy and will only use your information in accordance with our Privacy Policy.",
              },
            ],
          },
          {
            title: "6. Disclaimer of Warranties",
            items: [
              {
                subTitle: "6.1",
                description:
                  'Eye Academy is provided on an "as is" and "as available" basis without any warranties, express or implied.',
              },
              {
                subTitle: "6.2",
                description:
                  "Eye Academy does not warrant that the service will be uninterrupted, error-free, or free of viruses or other harmful components.",
              },
              {
                subTitle: "6.3",
                description:
                  "Eye Academy makes no guarantees regarding the accuracy, completeness, or reliability of any content on the platform.",
              },
            ],
          },
          {
            title: "7. Limitation of Liability",
            items: [
              {
                subTitle: "7.1",
                description:
                  "In no event shall Eye Academy be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of the service.",
              },
              {
                subTitle: "7.2",
                description:
                  "Eye Academy's total liability to you for all claims arising out of or relating to the service shall not exceed the amount paid by you, if any, for access to the service.",
              },
            ],
          },
          {
            title: "8. Governing Law",
            items: [
              {
                subTitle: "8.1",
                description:
                  "These Terms and Conditions shall be governed by and construed in accordance with the laws of the United Kingdom, without regard to its conflict of law provisions.",
              },
              {
                subTitle: "8.2",
                description:
                  "Any dispute arising out of or in connection with these Terms and Conditions shall be subject to the exclusive jurisdiction of the courts of the United Kingdom.",
              },
            ],
          },
          {
            title: "9. Changes to Terms and Conditions",
            items: [
              {
                subTitle: "9.1",
                description:
                  "Eye Academy reserves the right to update or modify these Terms and Conditions at any time without prior notice.",
              },
              {
                subTitle: "9.2",
                description:
                  "By continuing to use Eye Academy after any changes are made, you agree to be bound by the revised Terms and Conditions.",
              },
            ],
          },
        ],
      };
    },
  };
</script>

<style scoped>
  .terms-conditions {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    max-width: 800px;
    margin: 20px auto;
    padding: 20px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  .terms-conditions h1,
  .terms-conditions h2 {
    color: #333;
  }

  .terms-conditions p,
  .terms-conditions li {
    color: #666;
  }

  .terms-conditions a {
    color: #007bff;
  }

  .terms-conditions ul {
    list-style-type: none;
    padding: 0;
  }

  .terms-conditions li {
    margin-bottom: 10px;
  }

  .terms-conditions li strong {
    display: block;
  }
</style>
